// Translation dictionaries for the Aura landing page.
// Languages: az (Azerbaijani), ru (Russian), en (English).
// Russian is the source content; az/en are translations.
// Brand names (Aura, AppStore, Google Play, RuStore, Telegram) are left untranslated.

export const translations = {
  az: {
    // Navbar
    'nav.home': 'Ana səhifə',
    'nav.about': 'Tətbiq haqqında',
    'nav.contacts': 'Əlaqə',
    'nav.download': 'Yüklə',
    'nav.webapp': 'Veb versiya',
    'nav.login': 'Daxil ol',

    // Hero
    'hero.description':
      'Yeni mobil tətbiqimizlə rəqəmsal dövrdə tanışlıq maneələrini aşın',
    'hero.cta': 'Tətbiqi yüklə',
    'hero.webapp': 'Brauzerdə aç',

    // About
    'about.title': 'Tətbiq haqqında',
    'about.text':
      'Bu sadəcə tanışlıq platforması deyil; müasir texnologiyaların bir-birinə qarışdığı, unikal ünsiyyət məkanı yaratdığı məkandır',
    'about.ios': 'iOS üçün tətbiqi yüklə',
    'about.android': 'Android üçün tətbiqi yüklə',

    // Statement
    'description.content':
      'Səni tanış etmək və Abxaz mədəniyyətinə qovuşdurmaq üçün yaradılıb',

    // Info
    'info.title': 'Əlaqə',
    'info.description': 'Ən son yeniliklər üçün Telegram kanalımıza qoşul',
    'info.telegram': 'Telegram-a abunə ol',
    'info.mailLabel': 'Poçt',
    'info.emailDescription':
      'Yaranan hər hansı sual və ya əməkdaşlıqla bağlı dəstək xidməti ilə əlaqə saxlaya bilərsiniz. Aura komandası məmnuniyyətlə bütün suallarınızı cavablandıracaq',
    'info.email': 'E-poçt yazın',

    // Modal
    'modal.title': 'Tezliklə',
    'modal.text':
      'Tətbiq tezliklə bu mağazada əlçatan olacaq. Yeniliklərdən xəbərdar olun.',
    'modal.close': 'Bağla',

    // Footer
    'footer.title': 'Ümumdünya Sosial Şəbəkəsi',
    'footer.addressLabel': 'Ünvan:',
    'footer.companyName': '«Falcon» MMC',
    'footer.companyAddress': 'Abxaziya Respublikası, Suxum ş., Mira prospekti 16',
    'footer.companyRegistration': 'ORGN 108РА000782 · VÖEN 11008213',
    'footer.companyEmailLabel': 'Dəstək',
    'footer.privacy': 'Məxfilik Siyasəti (MDB)',
    'footer.cookie': 'Kuki Siyasəti',
    'footer.userAgreement': 'İstifadəçi Sazişi',
    'footer.personalData': 'Şəxsi məlumatların emalına razılıq',
    'footer.rights': '© 2026 Aura. Bütün hüquqlar qorunur.',
  },

  ru: {
    // Navbar
    'nav.home': 'Главная',
    'nav.about': 'О приложении',
    'nav.contacts': 'Контакты',
    'nav.download': 'Скачать',
    'nav.webapp': 'Веб-версия',
    'nav.login': 'Войти',

    // Hero
    'hero.description':
      'Преодолейте барьеры знакомств в цифровой эпохе с нашим новым мобильным приложением',
    'hero.cta': 'Скачать приложение',
    'hero.webapp': 'Открыть в браузере',

    // About
    'about.title': 'О приложении',
    'about.text':
      'Это не просто платформа для знакомств, это место, где современные технологии переплетаются, создавая уникальное пространство для общения',
    'about.ios': 'Скачать приложение на iOS',
    'about.android': 'Скачать приложение на Android',

    // Statement
    'description.content': 'Создан познакомить тебя и погрузить в абхазскую культуру',

    // Info
    'info.title': 'Контакты',
    'info.description':
      'Следите за обновлениями в телеграм-канале, чтобы быть в курсе последних обновлений',
    'info.telegram': 'Подписаться на Telegram',
    'info.mailLabel': 'Почта',
    'info.emailDescription':
      'По любым возникшим вопросам и сотрудничеству вы можете обратиться в службу поддержки. Команда Aura с удовольствием ответит на любые ваши вопросы',
    'info.email': 'Написать на почту',

    // Modal
    'modal.title': 'Скоро появится',
    'modal.text': 'Приложение скоро появится в этом магазине. Следите за обновлениями.',
    'modal.close': 'Закрыть',

    // Footer
    'footer.title': 'Всемирная социальная сеть',
    'footer.addressLabel': 'Адрес:',
    'footer.companyName': 'ООО «Falcon»',
    'footer.companyAddress': 'Республика Абхазия, г. Сухум, проспект Мира, 16',
    'footer.companyRegistration': 'ОГРН 108РА000782 · ИНН 11008213',
    'footer.companyEmailLabel': 'Поддержка',
    'footer.privacy': 'Политика конфиденциальности СНГ',
    'footer.cookie': 'Политика обработки данных cookie',
    'footer.userAgreement': 'Пользовательское соглашение',
    'footer.personalData': 'Согласие на обработку ПД',
    'footer.rights': '© 2026 Aura. Все права защищены.',
  },

  en: {
    // Navbar
    'nav.home': 'Home',
    'nav.about': 'About',
    'nav.contacts': 'Contacts',
    'nav.download': 'Download',
    'nav.webapp': 'Web app',
    'nav.login': 'Sign in',

    // Hero
    'hero.description':
      'Break down the barriers of dating in the digital age with our new mobile app',
    'hero.cta': 'Download the app',
    'hero.webapp': 'Open in browser',

    // About
    'about.title': 'About',
    'about.text':
      'Beyond just meeting new people, it’s a place where modern technology comes together, creating a unique place to connect',
    'about.ios': 'Download for iOS',
    'about.android': 'Download for Android',

    // Statement
    'description.content': 'Created to connect you and immerse you in Abkhaz culture',

    // Info
    'info.title': 'Contacts',
    'info.description':
      'Follow our Telegram channel to stay updated on the latest news!',
    'info.telegram': 'Subscribe on Telegram',
    'info.mailLabel': 'Mail',
    'info.emailDescription':
      'For any question or collaboration, you can contact our Support Team. The Aura team is here to answer all your questions.',
    'info.email': 'Send us an email',

    // Modal
    'modal.title': 'Coming soon',
    'modal.text':
      'The app will be available in this store soon. Stay tuned for updates.',
    'modal.close': 'Close',

    // Footer
    'footer.title': 'Worldwide Social Network',
    'footer.addressLabel': 'Address:',
    'footer.companyName': 'Falcon LLC',
    'footer.companyAddress': 'Republic of Abkhazia, Sukhum, Mira Avenue 16',
    'footer.companyRegistration': 'Reg. No. 108РА000782 · TIN 11008213',
    'footer.companyEmailLabel': 'Support',
    'footer.privacy': 'Privacy Policy (CIS)',
    'footer.cookie': 'Cookie Policy',
    'footer.userAgreement': 'User Agreement',
    'footer.personalData': 'Consent to Personal Data Processing',
    'footer.rights': '© 2026 Aura. All rights reserved.',
  },
};

// Languages available in the switcher, in display order (AZ, RU, US).
// label — короткий код рядом с флагом в переключателе лендинга,
// name — самоназвание языка для списка в настройках веб-версии.
export const LANGUAGES = [
  { code: 'az', label: 'AZ', name: 'Azərbaycan' },
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'en', label: 'US', name: 'English' },
];

export const DEFAULT_LANGUAGE = 'ru';
